<template>
  <div class="columns">
    <div class="column">
      <h4 class="is-size-4">Processes Run</h4>
      <div class="is-flex justify-between" v-for="process in audit.processes" :key="process.id">
        <p>{{ process.type }}</p>
        <p>
          {{ process.completed_at || 'Running...' }}
          <span v-if="process.completed_at">
            <br>
            {{ 'Runtime ' + process.runtime + 's' }}
          </span>
        </p>
      </div>
    </div>
  </div>  
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  
  computed: {
    ...mapGetters('audit', [
      'audit'
    ])
  }

}
</script>